import React, {useState, useEffect} from 'react';

async function getLocalURL(src) {
  let names = src.split('/');
  let name = names[names.length-1];
  // if ( name != 'TP-SeVs3d.mp4' ) 
  //   return doDownloadRange(videos);

  let opfsroot= await navigator.storage.getDirectory();
  let fileHandle = await opfsroot.getFileHandle(name, {create: false});
  // console.log( 'fileHandle', fileHandle )
  
  let file = await fileHandle.getFile();
  let fileSize = file.size;
  if ( fileSize > 0 ) {
    let res = await fetch(src, {method: 'HEAD'});
    // console.log( res )
    // console.log( 'Content-Length', res.headers.get('Content-Length') );
    let len = Number(res.headers.get('Content-Length'));
    if ( len == fileSize ) {
      // console.log( 'file', file );
      return URL.createObjectURL(file);
    }
  }
  return null;
}

const CachedVideo = ({ src, ...props }) => {
  const [videoSrc, setVideoSrc] = useState(src);

  useEffect(()=>{
    getLocalURL(src)
    .then((url)=>{
      console.log('Local URL:', url);
      if ( url ) {
        setVideoSrc(url);
      }
    })
    .catch((err)=>{
      // console.error(err);
      console.log('No Local cached URL found for ', src)
    })
  },[])

  return (
    <video src={videoSrc} {...props} />
  );
};

export default CachedVideo;
